import { ShotData } from '@/types/shot.types';

/**
 * Mock shot data for testing
 * Matches the data from the POC
 */
export const mockShots: ShotData[] = [
  {
    id: 'shot-1',
    start: { lat: 51.74007309573301, lng: -0.4072656032221573 },
    end: { lat: 51.73774221586487, lng: -0.406120310588988 },
    apexHeight: 50,
    color: 0x1a1b37, // 4 Aces team color
    playerInfo: {
      name: 'Johnson',
      teamName: '4 Aces',
      teamLogoUrl: '/images/teams/logo-4Aces.svg',
    },
    useTube: true,
    delay: 500,
    holeId: 'hole1',
  },
  {
    id: 'shot-2',
    start: { lat: 51.73926435210507, lng: -0.4063011462679095 },
    end: { lat: 51.73869200171382, lng: -0.40399716576609535 },
    apexHeight: 55,
    color: 0xe52322, // Fireballs team color
    playerInfo: {
      name: 'Garcia',
      teamName: 'Fireballs',
      teamLogoUrl: '/images/teams/logo-Fireballs.svg',
    },
    useTube: true,
    delay: 6000,
    holeId: 'hole2',
  },
  {
    id: 'shot-3',
    start: { lat: 51.739285089301966, lng: -0.40629444865017167 },
    end: { lat: 51.738932555659986, lng: -0.40425837285787075 },
    apexHeight: 50,
    color: 0x1a1b37, // 4 Aces team color
    playerInfo: {
      name: 'Reed',
      teamName: '4 Aces',
      teamLogoUrl: '/images/teams/logo-4Aces.svg',
    },
    useTube: true,
    delay: 9500,
    holeId: 'hole2',
  },
];
